module.exports = __webpack_public_path__ + "img/noimg.81e39494.jpg";